import script from "./AggProductPay.vue?vue&type=script&setup=true&lang=js"
export * from "./AggProductPay.vue?vue&type=script&setup=true&lang=js"

import "./AggProductPay.vue?vue&type=style&index=0&id=9b2d1732&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b2d1732"]])

export default __exports__